// Shared brand data — single source of truth for both apps. Generated/maintained;
// edit here, not the per-app overlays. APP_BUNDLES carries exam_name/exam_code (mobile
// reads them; web ignores). See docs/app-constant-usage-audit.md.
export const APP_BUNDLES = [
    {
        title: 'CISA',
        key: 'cisa',
        description: 'Certified Information Systems Auditor',
        exam_name: 'CISA',
        exam_code: '',
        bundle_firebase_collection_name: 'CISA',
    },
    {
        title: 'CISM',
        key: 'cism',
        description: 'Certified Information Security Manager',
        exam_name: 'CISM',
        exam_code: '',
        bundle_firebase_collection_name: 'CISM',
    },
    {
        title: 'CRISC',
        key: 'crisc',
        description: 'Certified in Risk and Information Systems Control',
        exam_name: 'CRISC',
        exam_code: '',
        bundle_firebase_collection_name: 'CRISC',
    },
    {
        title: 'CDPSE',
        key: 'cdpse',
        description: 'Certified Data Privacy Solutions Engineer',
        exam_name: 'CDPSE',
        exam_code: '',
        bundle_firebase_collection_name: 'CDPSE',
    }
]

export const EXAM_TITLES = {
  'cisa': 'CISA',
  'cism': 'CISM',
  'crisc': 'CRISC',
  'cdpse': 'CDPSE'
}

export const BUNDLE_APP_NAME = "ISACA_BUNDLE";

export const IS_BUNDLE_APP = true;

// Paywall headline (two lines; line2 is the accent line). Shared by web + mobile
// so both surfaces render one headline. Consumed via @learnzapp/core/pricing
// resolveHeadline, which fills a fallback if either line is blank.
export const PAYWALL_COPY = {
    headline: {
        line1: 'Everything You Need to',
        line2: 'Pass ISACA',
    },
};
